import script from "./5-no-balls-in-the-stock-market-you-shouldnt-bowl.vue?vue&type=script&setup=true&lang=js"
export * from "./5-no-balls-in-the-stock-market-you-shouldnt-bowl.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__